import {priority} from '@priority-software/priority-proto-api/lib';
import {PartsDetails} from './types';
import {
    FAMILY_FIELD_NAME,
    INACTIVE_FIELD_NAME,
    PART_FIELD_NAME,
    PART_PARENT_DEFAULT_FIELDS,
    TQUANT_FIELD_NAME
} from './consts';
import {number} from '@priority-software/priority-utils/lib/number';

export const objectifyParts = (selectedItems: Map<string, PartsDetails>) => {
    const selectedItemsObj: Array<{colName: string; value: string; shouldEnterRecord: string}> = [];
    selectedItems.forEach(item => {
        selectedItemsObj.push({
            colName: PART_FIELD_NAME,
            value: item.partName,
            shouldEnterRecord: 'N'
        });
        selectedItemsObj.push({
            colName: TQUANT_FIELD_NAME,
            value: number(item.selectedQuant) || '0',
            shouldEnterRecord: 'Y'
        });
    });
    return selectedItemsObj;
};

const preventColumnTypeFilter = [
    priority.netitems.form.ColumnType.Boolean,
    priority.netitems.form.ColumnType.Attachment
];

export const buildFilters = (
    columns: priority.netitems.form.IColumn[],
    selectedColumns?: string[],
    query?: string,
    selectedFamily?: string[]
): priority.netitems.form.IFilter[] => {
    //default filter - get only active parts

    const inactiveColId = columns.find(col => col.Name === INACTIVE_FIELD_NAME).ID;
    const filters: priority.netitems.form.IFilter[] = [
        {
            Condition: [
                {
                    ColumnID: inactiveColId,
                    Operator: priority.netitems.shared.ComparisonOperator.Eq,
                    Values: ['']
                }
            ]
        }
    ];
    if (columns) {
        //filter by query on the selected and default fields
        if (!!query) {
            const conditions = columns.reduce((acc, item) => {
                if (
                    (PART_PARENT_DEFAULT_FIELDS.includes(item.Name) ||
                        selectedColumns.includes(item.Name)) &&
                    !preventColumnTypeFilter.includes(item.Type) &&
                    Number(item.Width) >= query.length
                ) {
                    acc.push({
                        ColumnID: item.ID,
                        Operator: priority.netitems.shared.ComparisonOperator.Eq,
                        Values: [`*${query}*`],
                        IgnoreCase: true
                    });
                }
                return acc;
            }, []);

            filters.push({
                Condition: conditions,
                Operator: priority.netitems.shared.LogicalOperator.Or
            });
        }

        //filter by family
        if (!!selectedFamily?.length) {
            const familyColID = columns.find(col => col.Name === FAMILY_FIELD_NAME)?.ID;
            const familyCondition = [
                {
                    ColumnID: familyColID,
                    Operator: priority.netitems.shared.ComparisonOperator.In,
                    Values: [...selectedFamily]
                }
            ];

            filters.push({
                Condition: familyCondition
            });
        }
    }

    return filters;
};
